
import React from 'react';
import { Box, Paper, Typography, Stack, keyframes } from '@mui/material';
import { useLanguage } from "../../i18n/LanguageContext";
// Animations
const float = keyframes`
  0%, 100% { transform: translateY(0) rotate(0); }
  50% { transform: translateY(-15px) rotate(1deg); }
`;
const DashboardMockup = () => {
    const { t } = useLanguage();
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 700,
                position: 'relative',
                animation: `${float} 6s ease-in-out infinite`,
                perspective: '1000px',
                zIndex: 2
            }}
        >
          <Box sx={{ flex: 1, p: 0, overflow: 'hidden', borderRadius: 2 }}>
                        <img
                            src="/images/slidbar3.png"
                            alt="Slidbar"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover" // remplit tout l'écran du laptop
                            }}
                        />
                    </Box>
            {/* Laptop Base Bottom Effect */}
            <Box
                sx={{
                    width: '94%',
                    height: 10,
                    bgcolor: '#2a2a2a',
                    mx: 'auto',
                    borderRadius: '0 0 20px 20px',
                    boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
                }}
            />

            {/* Floating Glass Badge */}
            <Box
                sx={{
                    position: 'absolute',
                    top: '-15%',
                    right: '-5%',
                    p: 2,
                    bgcolor: 'rgba(255,255,255,0.7)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 4,
                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                    display: { xs: 'none', lg: 'block' },
                    animation: `${float} 5s ease-in-out infinite alternate-reverse`,
                    border: '1px solid rgba(255,255,255,0.5)'
                }}
            >
                <Typography variant="caption" fontWeight={800} color="secondary" sx={{ display: 'block', mb: 0.5 }}>
               { t("DashboardMockup.ERP") }  {/* ERP ENGINE */}
                </Typography>
                <Typography variant="body2" fontWeight={700} color="primary">
                { t("DashboardMockup.Active") }   {/* Active Monitoring */}
                </Typography>
            </Box>
        </Box>
    );
};

export default DashboardMockup;



























// import React from 'react';
// import { Box, Paper, Typography, Stack, keyframes } from '@mui/material';
// import { useLanguage } from "../../i18n/LanguageContext";
// // Animations
// const float = keyframes`
//   0%, 100% { transform: translateY(0) rotate(0); }
//   50% { transform: translateY(-15px) rotate(1deg); }
// `;

// const DashboardMockup = () => {
//     const { t } = useLanguage();
//     return (
//         <Box
//             sx={{
//                 width: '100%',
//                 maxWidth: 700,
//                 position: 'relative',
//                 animation: `${float} 6s ease-in-out infinite`,
//                 perspective: '1000px',
//                 zIndex: 2
//             }}
//         >
//             {/* Laptop Screen Body */}
//             <Paper
//                 elevation={24}
//                 sx={{
//                     width: '100%',
//                     aspectRatio: '16/10',
//                     backgroundColor: '#1a1a1a', // Laptop Bezel
//                     borderRadius: 4,
//                     p: 1.5,
//                     pb: 2.5,
//                     position: 'relative',
//                     overflow: 'hidden',
//                     border: '1px solid rgba(255,255,255,0.1)',
//                     boxShadow: '0 50px 100px rgba(0,0,0,0.3), inset 0 0 2px rgba(255,255,255,0.2)'
//                 }}
//             >
//                 {/* Internal Screen Content */}
//                 <Box
//                     sx={{
//                         width: '100%',
//                         height: '100%',
//                         borderRadius: 2,
//                         overflow: 'hidden',
//                         display: 'flex'
//                     }}
//                 >
//                     {/* Sidebar (facultatif) */}
//                     <Box sx={{ width: '18%', bgcolor: '#1D2558', p: 1.5 }}>
//                         <Box sx={{ width: '100%', height: 12, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1, mb: 3 }} />
//                         <Stack spacing={1.5}>
//                             {[40, 60, 50, 70, 45].map((w, i) => (
//                                 <Box
//                                     key={i}
//                                     sx={{
//                                         width: `${w}%`,
//                                         height: 6,
//                                         bgcolor: 'rgba(255,255,255,0.1)',
//                                         borderRadius: 1
//                                     }}
//                                 />
//                             ))}
//                         </Stack>
//                     </Box>

//                     {/* Main Dashboard Area avec l'image */}
//                     <Box sx={{ flex: 1, p: 0, overflow: 'hidden', borderRadius: 2 }}>
//                         <img
//                             src="/images/slidbar3.png"
//                             alt="Slidbar"
//                             style={{
//                                 width: "100%",
//                                 height: "100%",
//                                 objectFit: "cover" // remplit tout l'écran du laptop
//                             }}
//                         />
//                     </Box>
//                 </Box>

//                 {/* Camera Hole */}
//                 <Box
//                     sx={{
//                         position: 'absolute',
//                         top: 7,
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: 4,
//                         height: 4,
//                         bgcolor: 'rgba(255,255,255,0.1)',
//                         borderRadius: '50%'
//                     }}
//                 />
//             </Paper>

//             {/* Laptop Base Bottom Effect */}
//             <Box
//                 sx={{
//                     width: '94%',
//                     height: 10,
//                     bgcolor: '#2a2a2a',
//                     mx: 'auto',
//                     borderRadius: '0 0 20px 20px',
//                     boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
//                 }}
//             />

//             {/* Floating Glass Badge */}
//             <Box
//                 sx={{
//                     position: 'absolute',
//                     top: '-15%',
//                     right: '-5%',
//                     p: 2,
//                     bgcolor: 'rgba(255,255,255,0.7)',
//                     backdropFilter: 'blur(10px)',
//                     borderRadius: 4,
//                     boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
//                     display: { xs: 'none', lg: 'block' },
//                     animation: `${float} 5s ease-in-out infinite alternate-reverse`,
//                     border: '1px solid rgba(255,255,255,0.5)'
//                 }}
//             >
//                 <Typography variant="caption" fontWeight={800} color="secondary" sx={{ display: 'block', mb: 0.5 }}>
//                { t("DashboardMockup.ERP") }  {/* ERP ENGINE */}
//                 </Typography>
//                 <Typography variant="body2" fontWeight={700} color="primary">
//                 { t("DashboardMockup.Active") }   {/* Active Monitoring */}
//                 </Typography>
//             </Box>
//         </Box>
//     );
// };

// export default DashboardMockup;




























// import React from 'react';
// import { Box, Paper, Grid, Typography, Stack, alpha, keyframes } from '@mui/material';

// // Keyframes for animations
// const float = keyframes`
//   0%, 100% { transform: translateY(0) rotate(0); }
//   50% { transform: translateY(-15px) rotate(1deg); }
// `;

// const pulse = keyframes`
//   0% { transform: scale(1); opacity: 0.8; }
//   50% { transform: scale(1.05); opacity: 1; }
//   100% { transform: scale(1); opacity: 0.8; }
// `;

// const slideIn = keyframes`
//   from { transform: translateX(-20px); opacity: 0; }
//   to { transform: translateX(0); opacity: 1; }
// `;

// const drawLine = keyframes`
//   to { stroke-dashoffset: 0; }
// `;

// const DashboardMockup = () => {
//     return (
//         <Box
//             sx={{
//                 width: '100%',
//                 maxWidth: 700,
//                 position: 'relative',
//                 animation: `${float} 6s ease-in-out infinite`,
//                 perspective: '1000px',
//                 zIndex: 2
//             }}
//         >
//             {/* Laptop Screen Body */}
//             <Paper
//                 elevation={24}
//                 sx={{
//                     width: '100%',
//                     aspectRatio: '16/10',
//                     backgroundColor: '#1a1a1a', // Laptop Bezel
//                     borderRadius: 4,
//                     p: 1.5,
//                     pb: 2.5,
//                     position: 'relative',
//                     overflow: 'hidden',
//                     border: '1px solid rgba(255,255,255,0.1)',
//                     boxShadow: '0 50px 100px rgba(0,0,0,0.3), inset 0 0 2px rgba(255,255,255,0.2)'
//                 }}
//             >
//                 {/* Internal Screen Content */}
//                 <Box
//                     sx={{
//                         width: '100%',
//                         height: '100%',
//                         backgroundColor: '#f4f7fa',
//                         borderRadius: 2,
//                         overflow: 'hidden',
//                         display: 'flex'
//                     }}
//                 >
//                     {/* Sidebar */}
//                     <Box sx={{ width: '18%', bgcolor: '#1D2558', p: 1.5 }}>
//                         <Box sx={{ width: '100%', height: 12, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1, mb: 3 }} />
//                         <Stack spacing={1.5}>
//                             {[40, 60, 50, 70, 45].map((w, i) => (
//                                 <Box
//                                     key={i}
//                                     sx={{
//                                         width: `${w}%`,
//                                         height: 6,
//                                         bgcolor: 'rgba(255,255,255,0.1)',
//                                         borderRadius: 1,
//                                         animation: `${slideIn} 0.5s ease forwards`,
//                                         animationDelay: `${i * 0.1}s`
//                                     }}
//                                 />
//                             ))}
//                         </Stack>
//                     </Box>

//                     {/* Main Dashboard Area */}
//                     <Box sx={{ flex: 1, p: 2 }}>
//   <img
//     src="/images/slidbar3.png"
//     alt="Slidbar"
//     style={{
//       width: "100%",
//       height: "100%",
//       objectFit: "contain"  // ou "cover" si vous voulez remplir toute la Box
//     }}
//   />
// </Box>

//                 </Box>

//                 {/* Camera Hole */}
//                 <Box
//                     sx={{
//                         position: 'absolute',
//                         top: 7,
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                         width: 4,
//                         height: 4,
//                         bgcolor: 'rgba(255,255,255,0.1)',
//                         borderRadius: '50%'
//                     }}
//                 />
//             </Paper>

//             {/* Laptop Base Bottom Effect */}
//             <Box
//                 sx={{
//                     width: '94%',
//                     height: 10,
//                     bgcolor: '#2a2a2a',
//                     mx: 'auto',
//                     borderRadius: '0 0 20px 20px',
//                     boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
//                 }}
//             />

//             {/* Floating Glass Badges */}
//             <Box
//                 sx={{
//                     position: 'absolute',
//                     top: '-15%',
//                     right: '-5%',
//                     p: 2,
//                     bgcolor: 'rgba(255,255,255,0.7)',
//                     backdropFilter: 'blur(10px)',
//                     borderRadius: 4,
//                     boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
//                     display: { xs: 'none', lg: 'block' },
//                     animation: `${float} 5s ease-in-out infinite alternate-reverse`,
//                     border: '1px solid rgba(255,255,255,0.5)'
//                 }}
//             >
//                 <Typography variant="caption" fontWeight={800} color="secondary" sx={{ display: 'block', mb: 0.5 }}>ERP ENGINE</Typography>
//                 <Typography variant="body2" fontWeight={700} color="primary">Active Monitoring</Typography>
//             </Box>
//         </Box>
//     );
// };

// export default DashboardMockup;
